var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVersionIcon = function SvgVersionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1869F5",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M6.5 7h7M6.5 10h5M6.5 13h3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1869F5",
    strokeWidth: 1.6,
    d: "M3.8 4.5A2.2 2.2 0 0 1 6 2.3h10a2.2 2.2 0 0 1 2.2 2.2v13a2.2 2.2 0 0 1-2.2 2.2H6a2.2 2.2 0 0 1-2.2-2.2z"
  })));
};
export default SvgVersionIcon;